export default "__VITE_ASSET__ugPrx9uq__"